import { differenceInSeconds, format } from "date-fns";

import type { ClassSessionSummaryType } from "api/api-data-types";

export type SessionMetricsType = {
  attendanceSessionCount: number;
  totalAttendance: number;
  averageAttendance: number;
  highestAttendance: {
    percentage: number;
    date: string;
  };
  talkTimeSessionCount: number;
  totalStudentTalkTime: number;
  averageStudentTalkTime: number;
  highestStudentTalkTime: {
    percentage: number;
    date: string;
  };
};

export function computeSessionStats(sessions: ClassSessionSummaryType[]): SessionMetricsType {
  const stats = {
    attendanceSessionCount: 0,
    totalAttendance: 0,
    averageAttendance: 0,
    highestAttendance: { percentage: 0, date: "" },
    talkTimeSessionCount: 0,
    totalStudentTalkTime: 0,
    averageStudentTalkTime: 0,
    highestStudentTalkTime: { percentage: 0, date: "" },
  };
  if (sessions.length === 0) {
    return stats;
  }

  sessions.forEach((session) => {
    if (session.students.length === 0) return;

    const attendancePercentage =
      (session.attending_students.length / session.students.length) * 100;
    stats.totalAttendance += attendancePercentage;
    stats.attendanceSessionCount += 1;

    if (attendancePercentage > stats.highestAttendance.percentage) {
      stats.highestAttendance = {
        percentage: Math.round(attendancePercentage),
        date: format(session.start_time, "MMM d, yyyy"),
      };
    }

    const durationSeconds = differenceInSeconds(session.end_time, session.start_time);
    if (durationSeconds === 0) return;

    const talkTimePercentage = (session.student_talk_time_seconds / durationSeconds) * 100;
    stats.totalStudentTalkTime += talkTimePercentage;
    stats.talkTimeSessionCount += 1;

    if (talkTimePercentage > stats.highestStudentTalkTime.percentage) {
      stats.highestStudentTalkTime = {
        percentage: Math.round(talkTimePercentage),
        date: format(session.start_time, "MMM d, yyyy"),
      };
    }
  });

  stats.averageAttendance =
    stats.attendanceSessionCount > 0
      ? Math.round(stats.totalAttendance / stats.attendanceSessionCount)
      : 0;

  stats.averageStudentTalkTime =
    stats.talkTimeSessionCount > 0
      ? Math.round(stats.totalStudentTalkTime / stats.talkTimeSessionCount)
      : 0;

  return stats;
}
